import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { DashboardLayout, MetricsCard } from "src/components/dashboard";
import { Flex } from "src/components/ui";
import { theme } from "src/styles/Theme";
import { DashboardContainer } from "../dashboard/Dashboard";
import user from "src/assets/images/metrics/user.svg";
import artisan from "src/assets/images/metrics/artisan.svg";
import { ScaleLoader } from "react-spinners";
import BankTable from "src/components/Others/BankTable";
import OccupationTable from "src/components/Others/OccupationTable";
import { useAppDispatch, useAppSelector } from "src/store";
import { setBanks, useGetBanksQuery } from "src/store";
import { PaginationProps } from "src/components/ui/Pagination";

type Props = {};

const Banks = (props: Props) => {
  const dispatch = useAppDispatch();
  const { banks } = useAppSelector((state) => state.misc);
  const [Ppage, setPage] = useState(1);

  const [paginationData, setPaginationData] = useState<PaginationProps>({
    page: 0,
    pageSize: 0,
    total: 0,
    totalPages: 0,
  });

  const { data, error, isLoading } = useGetBanksQuery({
    page: Ppage,
    limit: 10,
  });

  useEffect(() => {
    if (data?.payload?.data) {
      dispatch(setBanks(data.payload.data));
    }
    if (data?.payload?.pagination) {
      setPaginationData(data.payload.pagination);
    }
  }, [data, dispatch]);
    useEffect(() => {
    document.title = "Bank's Page";
  }, []);

  return (
    <DashboardLayout pageTitle="Banks">
      <DashboardContainer>
        <ToastContainer />
        {isLoading ? (
          <div className="loader-container">
            <ScaleLoader color="#7E00C4" height={50} width={8} />
          </div>
        ) : (
          <BankTable
            rows={banks}
            Ppage={Ppage}
            setPage={setPage}
            paginationData={paginationData}
          />
        )}
      </DashboardContainer>
    </DashboardLayout>
  );
};

export default Banks;
